import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    Aangifte,
    Adres, BokkzAlgDataService, IncomeTaxEntity, OmschrijvingEnBedrag,
    Onderneming, Ondernemingsvorm,
    Periode,
    SpecificatieOnroerendeZaken,
    SpecificatiePriveGebruikAuto,
    SpecificatiePriveGebruikWoning
} from '@snelstart-ventures/fiscaal/domain-logic';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { BokkzIbDataService } from '@snelstart-ventures/fiscaal/domain-logic';
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {
    optionsLandcodesMetNLD
} from '../../../../gedeelde-componenten/gedeelde-componenten.component';
import { Event, NavigationEnd, Router } from '@angular/router';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'snelstart-venture-fiscaal-feature-prive-ontrekkingen-en-stortingen',
    templateUrl: './prive-ontrekkingen-en-stortingen.component.html',
    styleUrls: ['./prive-ontrekkingen-en-stortingen.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        SharedUiButtonModule,
        SharedUiDetailsModule,
        CommonModule
    ]
})
export class PriveOntrekkingenEnStortingenComponent implements OnInit, OnDestroy {

    @Input() public id!: string;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    public clientId!: string;
    private isSaving = false;
    private isCheckingRdw = false;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    public partnerBoolean = false;
    private focusedElementId: string | null = null;
    public showSpinner = true;
    public optionsLandcodes: SelectFormControlItem<string>[] = optionsLandcodesMetNLD;
    public ondernemingFG = {} as FormGroup;
    public ondernemingLength: any;
    public formStructure: any;

    public optionsJaNee: SelectFormControlItem<boolean>[] = [
        { value: true, label: 'Ja' },
        { value: false, label: 'Nee' }
    ];

    constructor(private fb: FormBuilder,
                private router: Router,
                public dataService: BokkzIbDataService,
                private dataAlgService: BokkzAlgDataService) {
        this.ondernemingFG = this.fb.group({
            ondernemingen: this.fb.array([])
        });
    }

    get ondernemingen(): FormArray {
        return this.ondernemingFG.get('ondernemingen') as FormArray;
    }

    createOndernemingFormGroup(onderneming?: Onderneming) {
        return this.dataService.createOndernemingFormGroup(onderneming);
    }

    // onttrekkingen prive gebruik auto
    getOnttrekkingPriveGebruikAuto(index: number): FormArray {
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        return outerGroup.get('onttrekkingPriveGebruikAuto') as FormArray;
    }

    addOnttrekkingPriveGebruikAuto(index: number): void {
        const innerGroup = this.fb.group<SpecificatiePriveGebruikAuto>({
            autoWordtPriveGebruikt: undefined,
            kenteken: undefined,
            catalogusPrijs: undefined,
            periodePriveGebruik: this.fb.group({
                begindatum: undefined as unknown as Date,
                einddatum: undefined as unknown as Date
            }),
            kilometerAdministratieAanwezig: undefined,
            kostenEnLastenVoorEigenRekening: undefined,
            priveGebruik: undefined
        });
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        const innerArray = outerGroup.get('onttrekkingPriveGebruikAuto') as FormArray;
        innerArray.push(innerGroup);
    }

    deleteOnttrekkingPriveGebruikAuto(outerIndex: number, innerIndex: number): void {
        const innerArray = this.getOnttrekkingPriveGebruikAuto(outerIndex);
        innerArray.removeAt(innerIndex);
        this.saveForm();
    }

    public createOnttrekkingPriveGebruikAutoFormGroup(onttrekkingPriveGebruikAuto?: SpecificatiePriveGebruikAuto): FormGroup {
        return this.fb.group<SpecificatiePriveGebruikAuto>({
            autoWordtPriveGebruikt: onttrekkingPriveGebruikAuto ? onttrekkingPriveGebruikAuto.autoWordtPriveGebruikt : undefined,
            kenteken: onttrekkingPriveGebruikAuto ? onttrekkingPriveGebruikAuto.kenteken : undefined,
            catalogusPrijs: onttrekkingPriveGebruikAuto ? onttrekkingPriveGebruikAuto.catalogusPrijs : undefined,
            periodePriveGebruik: this.createPeriodeFormGroup(onttrekkingPriveGebruikAuto?.periodePriveGebruik),
            kilometerAdministratieAanwezig: onttrekkingPriveGebruikAuto ? onttrekkingPriveGebruikAuto.kilometerAdministratieAanwezig : undefined,
            kostenEnLastenVoorEigenRekening: onttrekkingPriveGebruikAuto ? onttrekkingPriveGebruikAuto.kostenEnLastenVoorEigenRekening : undefined,
            priveGebruik: onttrekkingPriveGebruikAuto ? onttrekkingPriveGebruikAuto.priveGebruik : undefined
        });
    }

    onKentekenChangeControl(autoControl: FormGroup): void {
        if (this.isCheckingRdw) {
            return;
        }
        const kentekenControl = autoControl.get('kenteken')?.value;
        const bijtelling = autoControl.get('priveGebruik')?.value;
        const periodePriveGebruik = autoControl.get('periodePriveGebruik')?.value;
        const beginDatumProcessed = new Date(periodePriveGebruik.begindatum).toISOString();
        const eindDatumProcessed = new Date(periodePriveGebruik.einddatum).toISOString();
        let privebetaald = autoControl.get('kostenEnLastenVoorEigenRekening')?.value;
        if (kentekenControl && beginDatumProcessed > new Date('1970-01-01').toISOString() && eindDatumProcessed > new Date('1970-01-01').toISOString() && bijtelling == undefined) {
            if (privebetaald == undefined) {
                privebetaald = 0;
            }
            this.isCheckingRdw = true;
            const kenteken = kentekenControl;
            if (beginDatumProcessed && eindDatumProcessed) {
                this.dataService.getKentekenGegevens(kenteken.toUpperCase(), privebetaald, beginDatumProcessed, eindDatumProcessed).subscribe({
                    next: (response) => {
                        if (response.length > 0 && response[0]?.catalogusprijs) {
                            const catalogusPrijs = response[0].catalogusprijs;
                            const priveGebruik = response[0].bijtelling;
                            autoControl.patchValue({ catalogusPrijs, priveGebruik });
                        } else {
                            this.isCheckingRdw = false;
                            console.error('Kenteken niet gevonden.');
                        }
                    },
                    error: (error) => {
                        this.isCheckingRdw = false;
                        console.error('Fout bij ophalen van gegevens:', error);
                    },
                    complete: () => {
                        this.isCheckingRdw = false;
                    }
                });
            } else {
                this.isCheckingRdw = false;
            }
        }
    }

    // onttrekkingen overig
    getOnttrekkingOverig(index: number): FormArray {
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        return outerGroup.get('onttrekkingenOverig') as FormArray;
    }

    addOnttrekkingOverig(index: number): void {
        const innerGroup = this.fb.group<OmschrijvingEnBedrag>({
            omschrijving: undefined,
            bedrag: undefined
        });
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        const innerArray = outerGroup.get('onttrekkingenOverig') as FormArray;
        innerArray.push(innerGroup);
    }

    deleteOnttrekkingOverig(outerIndex: number, innerIndex: number): void {
        const innerArray = this.getOnttrekkingOverig(outerIndex);
        innerArray.removeAt(innerIndex);
        this.saveForm();
    }

    public createOnttrekkingOverigFormGroup(onttrekkingenOverig?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group<OmschrijvingEnBedrag>({
            omschrijving: onttrekkingenOverig ? onttrekkingenOverig.omschrijving : undefined,
            bedrag: onttrekkingenOverig ? onttrekkingenOverig.bedrag : undefined
        });
    }

    // onttrekkingen OG
    getOnttrekkingenOG(index: number): FormArray {
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        return outerGroup.get('onttrekkingOG') as FormArray;
    }

    addOnttrekkingenOG(index: number): void {
        const innerGroup = this.fb.group<SpecificatieOnroerendeZaken>({
            adresOnroerendeZaak: this.fb.group({
                straat: undefined,
                huisNummer: undefined,
                huisNummerToevoeging: undefined,
                postcode: undefined,
                woonplaats: undefined,
                landCode: 'NLD'
            }),
            waardeEconomischeVerkeer: undefined,
            boekwaardeOpMonentOnttrekking: undefined,
            transactieMetDerde: undefined,
            taxateurBetrokken: undefined,
            naamTaxateur: undefined
        });
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        const innerArray = outerGroup.get('onttrekkingOG') as FormArray;
        innerArray.push(innerGroup);
    }

    deleteOnttrekkingenOG(outerIndex: number, innerIndex: number): void {
        const innerArray = this.getOnttrekkingenOG(outerIndex);
        innerArray.removeAt(innerIndex);
        this.saveForm();
    }

    public createOntrekkingOGFormGroup(onttrekkingOG?: SpecificatieOnroerendeZaken): FormGroup {
        return this.fb.group<SpecificatieOnroerendeZaken>({
            adresOnroerendeZaak: this.createAdresFormGroup(onttrekkingOG?.adresOnroerendeZaak),
            waardeEconomischeVerkeer: onttrekkingOG ? onttrekkingOG.waardeEconomischeVerkeer : undefined,
            boekwaardeOpMonentOnttrekking: onttrekkingOG ? onttrekkingOG.boekwaardeOpMonentOnttrekking : undefined,
            transactieMetDerde: onttrekkingOG ? onttrekkingOG.transactieMetDerde : false,
            taxateurBetrokken: onttrekkingOG ? onttrekkingOG.taxateurBetrokken : false,
            naamTaxateur: onttrekkingOG ? onttrekkingOG.naamTaxateur : ''
        });
    }

    // onttrekkingen prive gebruik woning
    getOnttrekkingPriveGebruikWoning(index: number): FormArray {
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        return outerGroup.get('onttrekkingPriveGebruikWoning') as FormArray;
    }

    addOnttrekkingPriveGebruikWoning(index: number): void {
        const innerGroup = this.fb.group<SpecificatiePriveGebruikWoning>({
            adresWoning: this.fb.group({
                straat: undefined,
                huisNummer: undefined,
                huisNummerToevoeging: undefined,
                postcode: undefined,
                woonplaats: undefined,
                landCode: 'NLD'
            }),
            wozWaarde: undefined,
            periodeBewoning: this.fb.group({
                begindatum: undefined,
                einddatum: undefined
            }),
            percentageGerechtigd: undefined,
            berekendeOnttrekking: undefined
        });
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        const innerArray = outerGroup.get('onttrekkingPriveGebruikWoning') as FormArray;
        innerArray.push(innerGroup);
    }

  deleteOnttrekkingPriveGebruikWoning(outerIndex: number, innerIndex: number): void {
    const innerArray = this.getOnttrekkingPriveGebruikWoning(outerIndex);
    innerArray.removeAt(innerIndex);
    this.saveForm()
  }

  public createOnttrekkingPriveGebruikWoningFormGroup(onttrekkingPriveGebruikWoning?: SpecificatiePriveGebruikWoning): FormGroup {
    return this.fb.group<SpecificatiePriveGebruikWoning>({
      adresWoning: this.createAdresFormGroup(onttrekkingPriveGebruikWoning?.adresWoning),
      percentageGerechtigd: onttrekkingPriveGebruikWoning ? onttrekkingPriveGebruikWoning.percentageGerechtigd : undefined,
      wozWaarde: onttrekkingPriveGebruikWoning ? onttrekkingPriveGebruikWoning.wozWaarde : undefined,
      periodeBewoning: this.createPeriodeFormGroup(onttrekkingPriveGebruikWoning?.periodeBewoning),
      berekendeOnttrekking: onttrekkingPriveGebruikWoning ? onttrekkingPriveGebruikWoning.berekendeOnttrekking : undefined,
    })
  }

  // stortingen OG
  getStortingenOG(index: number): FormArray {
    const outerGroup = this.ondernemingen.at(index) as FormGroup;
    return outerGroup.get('stortingOG') as FormArray;
  }

  addStortingOG(index: number): void {
    const innerGroup = this.fb.group<SpecificatieOnroerendeZaken>({
      adresOnroerendeZaak: this.fb.group({
        straat: undefined,
        huisNummer: undefined,
        huisNummerToevoeging: undefined,
        postcode: undefined,
        woonplaats: undefined,
        landCode: 'NLD',
      }),
      waardeEconomischeVerkeer: undefined,
      taxateurBetrokken: undefined,
      naamTaxateur: undefined,
    });
    const outerGroup = this.ondernemingen.at(index) as FormGroup;
    const innerArray = outerGroup.get('stortingOG') as FormArray;
    innerArray.push(innerGroup);
  }

  deleteStortingOG(outerIndex: number, innerIndex: number): void {
    const innerArray = this.getStortingenOG(outerIndex);
    innerArray.removeAt(innerIndex);
    this.saveForm()
  }

  public createStortingOGFormGroup(stortingOG?: SpecificatieOnroerendeZaken): FormGroup {
    return this.fb.group<SpecificatieOnroerendeZaken>({
      adresOnroerendeZaak: this.createAdresFormGroup(stortingOG?.adresOnroerendeZaak),
      waardeEconomischeVerkeer: stortingOG ? stortingOG.waardeEconomischeVerkeer : undefined,
      boekwaardeOpMonentOnttrekking: stortingOG ? stortingOG.boekwaardeOpMonentOnttrekking : undefined,
      transactieMetDerde: stortingOG ? stortingOG.transactieMetDerde : false,
      taxateurBetrokken: stortingOG ? stortingOG.taxateurBetrokken : false,
      naamTaxateur: stortingOG ? stortingOG.naamTaxateur : undefined,

    })
  }

  // stortingen overig
  getStortingenOverig(index: number): FormArray {
    const outerGroup = this.ondernemingen.at(index) as FormGroup;
    return outerGroup.get('stortingenOverig') as FormArray;
  }

  addStortingenOverig(index: number): void {
    const innerGroup = this.fb.group<OmschrijvingEnBedrag>({
      omschrijving: '',
      bedrag: undefined,
    });
    const outerGroup = this.ondernemingen.at(index) as FormGroup;
    const innerArray = outerGroup.get('stortingenOverig') as FormArray;
    innerArray.push(innerGroup);
  }

  deleteStortingenOverig(outerIndex: number, innerIndex: number): void {
    const innerArray = this.getStortingenOverig(outerIndex);
    innerArray.removeAt(innerIndex);
    this.saveForm()
  }

  public createStortingenOverigFormGroup(stortingenOverig?: OmschrijvingEnBedrag): FormGroup {
    return this.fb.group<OmschrijvingEnBedrag>({
      omschrijving: stortingenOverig ? stortingenOverig.omschrijving : undefined,
      bedrag: stortingenOverig ? stortingenOverig.bedrag : undefined
    })
  }

  public createAdresFormGroup(adres?: Adres) {
    return this.fb.group({
      straat: adres?.straat || undefined,
      huisNummer: adres?.huisNummer || undefined,
      huisNummerToevoeging: adres?.huisNummerToevoeging || undefined,
      postcode: adres?.postcode || undefined,
      woonplaats: adres?.woonplaats || undefined,
      landCode: adres?.landCode || 'NLD',
    })
  }

  public createPeriodeFormGroup(periode?: Periode) {
    return this.fb.group({
      begindatum: periode?.begindatum || undefined,
      einddatum: periode?.einddatum || undefined,
    })
  }

  public ngOnInit(): void {
    this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
      this.incomeTaxEntity = incomeTaxEntity;
      if (incomeTaxEntity.aangifte) {
        this.updateForm();
        this.partner.subscribe((partner) => {
          this.partnerBoolean = partner
          this.ondernemingFG.reset()
          this.updateForm();
        });
        this.ondernemingFG.valueChanges.subscribe(value => {
          this.formStructure = value;
        });
        this.ondernemingen.valueChanges.subscribe(value => {
          this.ondernemingLength = value
        });
      }
    });
    this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
      this.clientId = client.sstRelationId!;
    });
    this.routerSubscription = this.router.events
      .pipe(
        filter(
          (event: Event): event is NavigationEnd =>
            event instanceof NavigationEnd,
        ),
      )
      .subscribe((event: NavigationEnd) => {
        this.handleUrlChange(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.ondernemingFG.dirty
  }

  private updateForm(): void {
    let ondernemingenLijst = this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen || [];
    this.partner.subscribe((partner) => {
      if (partner) {
        ondernemingenLijst = this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen || [];
      }
    });
    const formArray = this.ondernemingFG.get('ondernemingen') as FormArray;
    const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > ondernemingenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Update ondernemingen
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(ondernemingenLijst[i]);
            } else {
                const formGroup = this.createOndernemingFormGroup(ondernemingenLijst[i]);
                formArray.push(formGroup);
            }
        }
        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }

        // Update ontrekkingen privegebruik auto
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            const onderneming = ondernemingenLijst[i];
            const onttrekkingPriveGebruikAuto = onderneming.onttrekkingPriveGebruikAuto || [];
            const onttrekkingPriveGebruikAutoFormArray = this.getOnttrekkingPriveGebruikAuto(i);

            while (onttrekkingPriveGebruikAutoFormArray.length > onttrekkingPriveGebruikAuto.length) {
                onttrekkingPriveGebruikAutoFormArray.removeAt(onttrekkingPriveGebruikAutoFormArray.length - 1);
            }

            for (let d = 0; d < onttrekkingPriveGebruikAuto.length; d++) {
                if (d < onttrekkingPriveGebruikAutoFormArray.length) {
                    const control = onttrekkingPriveGebruikAutoFormArray.at(d) as FormGroup;
                    control.patchValue(onttrekkingPriveGebruikAuto[d]);

                    // Conditional logic for 'priveGebruik'
                    const autoWordtPriveGebruikt = control.value.autoWordtPriveGebruikt;
                    const kilometerAdministratieAanwezig = control.value.kilometerAdministratieAanwezig;

                    if (!autoWordtPriveGebruikt && kilometerAdministratieAanwezig) {
                        // Set 'priveGebruik' to 0 and disable it
                        control.patchValue({ priveGebruik: 0, kostenEnLastenVoorEigenRekening: 0 });
                        control.get('priveGebruik')?.disable();
                        control.get('kostenEnLastenVoorEigenRekening')?.disable();
                    } else {
                        control.get('priveGebruik')?.enable();
                        control.get('kostenEnLastenVoorEigenRekening')?.enable();
                        if (control.get('kenteken')?.value) {
                            this.onKentekenChangeControl(control);
                        }

                    }
                } else {
                    const onttrPrivegebruikAuto = this.createOnttrekkingPriveGebruikAutoFormGroup(onttrekkingPriveGebruikAuto[d]);
                    onttrekkingPriveGebruikAutoFormArray.push(onttrPrivegebruikAuto);

                    // Additional logic for newly added FormGroup
                    const autoWordtPriveGebruikt = onttrPrivegebruikAuto.value.autoWordtPriveGebruikt;
                    const kilometerAdministratieAanwezig = onttrPrivegebruikAuto.value.kilometerAdministratieAanwezig;

                    if (!autoWordtPriveGebruikt && kilometerAdministratieAanwezig) {
                        // Set 'priveGebruik' to 0 and disable it
                        onttrPrivegebruikAuto.patchValue({ priveGebruik: 0, kostenEnLastenVoorEigenRekening: 0 });
                        onttrPrivegebruikAuto.get('priveGebruik')?.disable();
                        onttrPrivegebruikAuto.get('kostenEnLastenVoorEigenRekening')?.disable();
                    } else {
                        // Enable 'priveGebruik' if conditions are not met
                        onttrPrivegebruikAuto.get('priveGebruik')?.enable();
                        onttrPrivegebruikAuto.get('kostenEnLastenVoorEigenRekening')?.enable();
                    }
                }
            }
        }


        // Update ontrekkingen overig
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            const onderneming = ondernemingenLijst[i];
            const onttrekkingenOverig = onderneming.onttrekkingenOverig || [];
            const onttrekkingOverigFormArray = this.getOnttrekkingOverig(i);

            while (onttrekkingOverigFormArray.length > onttrekkingenOverig.length) {
                onttrekkingOverigFormArray.removeAt(onttrekkingOverigFormArray.length - 1);
            }
            for (let f = 0; f < onttrekkingenOverig.length; f++) {
                const onttrekking = onttrekkingenOverig[i];
                if (onttrekking.bedrag != undefined && onttrekking.bedrag < 0) {
                    onttrekking.bedrag = onttrekking.bedrag * -1;
                }
                if (f < onttrekkingOverigFormArray.length) {
                    const control = onttrekkingOverigFormArray.at(f) as FormGroup;
                    control.patchValue(onttrekkingenOverig[f]);
                } else {
                    const onttrPriveOverig = this.createOnttrekkingOverigFormGroup(onttrekkingenOverig[f]);
                    onttrekkingOverigFormArray.push(onttrPriveOverig);
                }
            }
        }
        // Update ontrekkingen OG
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            const onderneming = ondernemingenLijst[i];
            const onttrekkingOG = onderneming.onttrekkingOG || [];
            const onttrekkkingenOGFormArray = this.getOnttrekkingenOG(i);

            while (onttrekkkingenOGFormArray.length > onttrekkingOG.length) {
                onttrekkkingenOGFormArray.removeAt(onttrekkkingenOGFormArray.length - 1);
            }
            for (let c = 0; c < onttrekkingOG.length; c++) {
                const woning = onttrekkingOG[i];
                if (woning.adresOnroerendeZaak?.postcode) {
                    woning.adresOnroerendeZaak.postcode = this.formatPostcode(woning.adresOnroerendeZaak.postcode);
                }
                if (c < onttrekkkingenOGFormArray.length) {
                    const control = onttrekkkingenOGFormArray.at(c) as FormGroup;
                    control.patchValue(onttrekkingOG[c]);
                } else {
                    const onttrOG = this.createOntrekkingOGFormGroup(onttrekkingOG[c]);
                    onttrekkkingenOGFormArray.push(onttrOG);
                }
            }
        }
        // Update ontrekkingen privegebruik woning
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            const onderneming = ondernemingenLijst[i];
            const onttrekkingPriveGebruikWoning = onderneming.onttrekkingPriveGebruikWoning || [];
            const onttrekkingPriveGebruikWoningFormArray = this.getOnttrekkingPriveGebruikWoning(i);

            while (onttrekkingPriveGebruikWoningFormArray.length > onttrekkingPriveGebruikWoning.length) {
                onttrekkingPriveGebruikWoningFormArray.removeAt(onttrekkingPriveGebruikWoningFormArray.length - 1);
            }
            for (let e = 0; e < onttrekkingPriveGebruikWoning.length; e++) {
                const woning = onttrekkingPriveGebruikWoning[i];
                if (woning.adresWoning?.postcode) {
                    woning.adresWoning.postcode = this.formatPostcode(woning.adresWoning.postcode);
                }

                if (e < onttrekkingPriveGebruikWoningFormArray.length) {
                    const control = onttrekkingPriveGebruikWoningFormArray.at(e) as FormGroup;
                    control.patchValue(onttrekkingPriveGebruikWoning[e]);
                } else {
                    const onttrPrivegebruikWoning = this.createOnttrekkingPriveGebruikWoningFormGroup(onttrekkingPriveGebruikWoning[e]);
                    onttrekkingPriveGebruikWoningFormArray.push(onttrPrivegebruikWoning);
                }
            }
        }
        // Update storting OG
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            const onderneming = ondernemingenLijst[i];
            const stortingOG = onderneming.stortingOG || [];
            const stortingOGFormArray = this.getStortingenOG(i);

            while (stortingOGFormArray.length > stortingOG.length) {
                stortingOGFormArray.removeAt(stortingOGFormArray.length - 1);
            }
            for (let g = 0; g < stortingOG.length; g++) {
                const woning = stortingOG[i];
                if (woning.adresOnroerendeZaak?.postcode) {
                    woning.adresOnroerendeZaak.postcode = this.formatPostcode(woning.adresOnroerendeZaak.postcode);
                }
                if (g < stortingOGFormArray.length) {
                    const control = stortingOGFormArray.at(g) as FormGroup;
                    control.patchValue(stortingOG[g]);
                } else {
                    const stortOG = this.createStortingOGFormGroup(stortingOG[g]);
                    stortingOGFormArray.push(stortOG);
                }
            }
        }
        // Update stortingen overig
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            const onderneming = ondernemingenLijst[i];
            const stortingenOverig = onderneming.stortingenOverig || [];
            const stortingenOverigFormArray = this.getStortingenOverig(i);

            while (stortingenOverigFormArray.length > stortingenOverig.length) {
                stortingenOverigFormArray.removeAt(stortingenOverigFormArray.length - 1);
            }
            for (let h = 0; h < stortingenOverig.length; h++) {
                if (h < stortingenOverigFormArray.length) {
                    const control = stortingenOverigFormArray.at(h) as FormGroup;
                    control.patchValue(stortingenOverig[h]);
                } else {
                    const stortOverig = this.createStortingenOverigFormGroup(stortingenOverig[h]);
                    stortingenOverigFormArray.push(stortOverig);
                }
            }
        }
    }

    saveForm(): void {
        this.ondernemingFG.updateValueAndValidity();
        setTimeout(() => {
            if (!this.partnerBoolean) {
                this.incomeTaxEntity.aangifte = {
                    ...this.incomeTaxEntity.aangifte,
                    box1: {
                        ...this.incomeTaxEntity.aangifte?.box1,
                        winstUitOnderneming: {
                            ...this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming,
                            ondernemingen: this.ondernemingFG.getRawValue().ondernemingen
                        }
                    }
                } as Aangifte;
                this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

            } else {
                this.incomeTaxEntity.aangifte = {
                    ...this.incomeTaxEntity.aangifte,
                    partnerAangifte: {
                        ...this.incomeTaxEntity.aangifte?.partnerAangifte,
                        box1: {
                            ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1,
                            winstUitOnderneming: {
                                ...this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming,
                                ondernemingen: this.ondernemingFG.getRawValue().ondernemingen
                            }
                        }
                    }
                } as Aangifte;
                this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            }
        }, 0);
    }

    private getRelevantAangifte(): Aangifte | undefined {
        return this.partnerBoolean
            ? this.incomeTaxEntity.aangifte?.partnerAangifte
            : this.incomeTaxEntity.aangifte;
    }

    private getOndernemingen(): Onderneming[] | undefined {
        const aangifte = this.getRelevantAangifte();
        return aangifte?.box1?.winstUitOnderneming?.ondernemingen;
    }

    public heeftOndernemingen(): boolean {
        const ondernemingen = this.getOndernemingen();
        return !!ondernemingen && ondernemingen.length > 0;
    }

    public heeftSamenwerkingsverband(): boolean {
        const ondernemingen = this.getOndernemingen();
        return !!ondernemingen?.[0]?.ondernemingsvorm &&
            ondernemingen[0].ondernemingsvorm !== Ondernemingsvorm.EENMANSZAAK;
    }

    formatPostcode(postcode: string | null | undefined): string {
        if (!postcode) return ''; // Retourneer een lege string als postcode null of undefined is

        // Verwijder alle niet-alfanumerieke tekens (bijv. spaties)
        const cleanedPostcode = postcode.replace(/[^a-zA-Z0-9]/g, '');

        // Zorg voor 4 cijfers en 2 hoofdletters
        if (cleanedPostcode.length >= 4) {
            const cijfers = cleanedPostcode.substring(0, 4).replace(/\D/g, ''); // Alleen cijfers
            const letters = cleanedPostcode.substring(4, 6).replace(/[^a-zA-Z]/g, '').toUpperCase(); // Alleen letters
            return `${cijfers}${letters}`;
        }

        return cleanedPostcode; // Als de postcode te kort is, retourneer de schoongemaakte versie
    }

}
